import {toString} from './toString'

export function urlEncode(fixed: TemplateStringsArray, ...args: any[]): string {
    let url = ''
    for (const [idx, strPart] of fixed.entries()) {
        url += strPart + encodeURIComponent(toString(args[idx]))
    }
    return url
}
